  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
//import TextField                                           from '@material-ui/core/TextField';
//import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';

  import ExpansionPanel                                      from '@material-ui/core/ExpansionPanel';
  import ExpansionPanelSummary                               from '@material-ui/core/ExpansionPanelSummary';
  import ExpansionPanelDetails                               from '@material-ui/core/ExpansionPanelDetails';
//import Typography                                          from '@material-ui/core/Typography';
  import ExpandMoreIcon                                      from '@material-ui/icons/ExpandMore';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomButton                                        from "components/CustomButtons/Button.jsx";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
//import { wu_Utilities }                                    from "../../_services";
  //------
  // Style
  //------
  import SettingsHelpStyle                                   from "./SettingsHelpStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
//import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //----------
  // variables
  //----------
  const filename = "SettingsHelp ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

class SettingsHelp extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      viewPleaseWait_hidden                                : true,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                 = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                = this.dialog_handleClose.bind(this);
    this.startSpinners                                     = this.startSpinners.bind(this);
    this.stopSpinners                                      = this.stopSpinners.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    if(api.print_logs){console.log(methName+localStorage.getItem("curr_view")+",history.length="+history.length);}
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            <div style={{ marginTop: 25 }}>
              <div className={classes.labelHeader}>{this.NSInforString("Help_title")}</div>
              <div className={classes.logo}><img src={logo} alt="logo" /></div>
            </div>

            <div style={{ marginTop:20, marginBottom:20 }}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_01")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_01")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_02")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_02")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_03")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_03")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_04")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_04")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_05")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_05")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_06")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_06")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_07")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_07")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_08")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_08")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_09")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_09")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_10")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_10")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_11")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_11")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_12")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_12")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_13")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_13")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_14")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_14")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_15")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_15")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_16")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_16")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_17")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_17")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_18")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_18")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <div className={classes.lbl_question}>{this.NSInforString("question_19")}</div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.lbl_answer}>{this.NSInforString("answer_19")}</div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </GridItem>

                {localStorage.getItem("lang")!=="en" ? ( "" ) : (
                  <GridItem xs={12} sm={12} md={12}>
                    <ExpansionPanel>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <div className={classes.lbl_question}>{this.NSInforString("question_20")}</div>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <div className={classes.lbl_answer}>{this.NSInforString("answer_20")}</div>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </GridItem>
                )}
                {localStorage.getItem("lang")!=="en" ? ( "" ) : (
                  <GridItem xs={12} sm={12} md={12}>
                    <ExpansionPanel>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <div className={classes.lbl_question}>{this.NSInforString("question_21")}</div>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <div className={classes.lbl_answer}>{this.NSInforString("answer_21")}</div>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </GridItem>
                )}
              </GridContainer>
            </div>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //https://material-ui.com/components/lists/
  // function generate(element) {
  //   return [0, 1, 2].map(value =>
  //     React.cloneElement(element, {
  //       key: value,
  //     }),
  //   );
  // }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    //if(api.print_logs){console.log(stateVar+" "+event.target.value);}

    // if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
    //   this.setState({"textField0":eventTMP.trim(),});
    // }

    this.setState({ [stateVar]:event.target.value+"" });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
}
SettingsHelp.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(SettingsHelpStyle)(SettingsHelp)
);
